<template>
  <div class="IconPlayBroadcast" @click="onPlayPauseClick">
    <button :class="['IconPlayBroadcast', getIcon, { large: large }]"></button><label v-if="label">{{label}}</label>
  </div>
</template>

<script>
export default {
  name: 'IconPlayBroadcast',
  props: {
    title: { type: String, required: true },
    url: { type: String, required: true },
    variation: { type: String, default: 'player' },
    large: { type: Boolean, default: false },
    pageUrl: { type: String },
    label: String
  },
  computed: {
    broadcast () {
      return this.$store.state.audio.broadcast
    },
    isLoaded () {
      return this.$store.state.audio.broadcast.url === this.url
    },
    getIcon () {
      const isPaused = this.$store.state.audio.broadcast.paused
      const variation = this.variation
      return !isPaused && this.isLoaded ? 'icon-' + variation + '-pause' : 'icon-' + variation + '-play'
    }
  },
  methods: {
    onPlayPauseClick () {
      const { isLoaded, title, url, pageUrl } = this
      if (!isLoaded) this.$store.dispatch('loadBroadcast', { title, url, pageUrl })
      else this.$store.dispatch('toggleBroadcast')
    }
  }
}
</script>

<style scoped>
.IconPlayBroadcast {

}
</style>

<style>
  .no-touch .hover-icon .IconPlayBroadcast:hover {
    border-color: var(--accent);
  }
</style>